import React, { useEffect, useState } from "react";
import { useAuthContext } from "../../../hooks/useAuthContext";
import axios from "axios";
import { ApiConnectionString } from "../../../constants/ApiConntection";
import {useNavigate } from "react-router-dom";
import NoImagePlaceholder from "../../../assets/NoImagePlaceholder.png";
import LoadingSpinner from "../../../components/LoadingSpinner";

export default function ShowAccessModal({ cancelModal, selecetedToken }) {
  const [events, setEvents] = useState([]);

  const [isLoading, setIsLoading] = useState(true);
  const { user } = useAuthContext();
  const navi = useNavigate();

  const fetchData = async () => {
    setIsLoading(true);
    try {
      const accessResponse = await axios.get(
        `${ApiConnectionString}/api/ProductAccess/${selecetedToken.viewProduct.id}`,
        {
          headers: { Authorization: `Bearer ${user.token}` },
        }
      );
      if (accessResponse.status == 200) {
        setEvents(accessResponse.data);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (!selecetedToken.viewProduct.totalAccess) {
      fetchData();
    }else{
      setIsLoading(false)
    }
  }, [user]);

  if (isLoading) {
    return (
      <div className="send-modal-overlay">
        <div className="send-modal">
          <LoadingSpinner />
        </div>
      </div>
    );
  } else {
    return (
      <div className="send-modal-overlay">
        <div className="send-modal">

      
      
         <div className="blueBanner">
            <p className="fw-bold m-2 p-2 fontSize20">
              {selecetedToken.viewProduct.name}
            </p>
          </div>

          <button
            type="button"
            className="close-button"
            onClick={cancelModal}
            aria-label="Close"
          >
            &times;
          </button>

          <div
            onClick={() => navi(`/club/${selecetedToken.viewClubs.id}`)}
            className="text-center pointer"
          >
            <p className="red-text fw-bold">{selecetedToken.viewClubs.name}</p>
            <div className="d-flex justify-content-center">
              <div className="circle-crop">
                <img
                  src={
                    selecetedToken.viewClubs.image
                      ? `${ApiConnectionString}/api/ClubProfileImage/${selecetedToken.viewClubs.id}`
                      : NoImagePlaceholder
                  }
                  alt="Club Image"
                  className="mt-0"
                />
              </div>
            </div>
          </div>

          {selecetedToken.viewProduct.totalAccess && (
            <p className="fw-bold text-center">Allows access to all classes</p>
          )}
          {!selecetedToken.viewProduct.totalAccess && (
            <p className="fw-bold text-center">
              The following classes are available with{" "}
              {selecetedToken.viewProduct.name}
            </p>
          )}
          {!selecetedToken.viewProduct.totalAccess && (
            <table className="custom-table">
              <thead className="blueBanner">
                <tr>
                  <th>Class</th>
                  <th>Day</th>
                  <th>Times</th>
                </tr>
              </thead>
              <tbody>
                {events.map((event) => (
                  <tr key={event.id}>
                    <td>{event.name}</td>
                    <td>{event.day}</td>
                    <td>
                      {event.timeIn} - {event.timeOut}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )} 

          <div className="send-modal-footer">
            <button
              onClick={cancelModal}
              className="pointer cancelButton fw-bold mx-2 px-3"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    );
  }
}
